import * as actions from './actionTypes';

export interface IFileStore {
    file?: Blob | MediaSource | null,
    isLoading?: boolean,
    error?: string
}

const INITIAL_STATE:IFileStore = {
    file: null,
    isLoading: false,
    error: ""
}

const FileData = (state = INITIAL_STATE, action:{type: string, payload: any }) => {
    switch (action.type) {
        case actions.FETCH_FILE:
            state = {
                ...state,
               isLoading: true,
            }
            break;
        
        case actions.FILE_SUCCESS:
            state = {
                ...state,
                isLoading: false,
                file: action.payload
            }
            break;

        case actions.FILE_ERROR:
            state = {
                ...state,
                isLoading: false,
                error: action.payload
            }
            break;

        case actions.FILE_REMOVE:
            state = {
                ...state,
                ...INITIAL_STATE
            }
            break;
        
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default FileData;